import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwMdFormContextInfo, DwMetaDataFormApi, DwMetaDataFormStateService } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, CheckRideRequestEntity, CheckRideRequestPaymentPartyAllItems } from '../../../../meta-data/app-meta-data.service';
import { PaymentRepositoryService } from '../../../payments/services/payment-repository.service';
// import { CheckrideVariables } from '../../../applicant/models/checkride-variables.model';
import { FormGroup } from '@angular/forms';
import { ExaminerBookingVariableContext } from '../../models/examiner-booking-variable-context.model';

@DwComponent({
  key: 'school-booking-payment-details-section',
  name: 'School Booking Payment Details',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.CheckRideRequest,
  isGlobal: false
})
@Component({
  selector: 'app-school-booking-payment-details',
  templateUrl: './school-booking-payment-details.component.html',
  styleUrls: ['./school-booking-payment-details.component.scss']
})
export class SchoolBookingPaymentDetailsComponent implements OnInit {
  paymentDiscountCode: string;

  paymentDiscountResult: any;
  formApi: DwMetaDataFormApi;
  checkrideRequest: CheckRideRequestEntity;
  variableContext: ExaminerBookingVariableContext;

  hideDiscount = true;

  constructor(
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private paymentRepositoryService: PaymentRepositoryService,

  ) {
    this.formApi = dwMetaDataFormStateService.state.formApi;
  }

  ngOnInit(): void {
    this.checkrideRequest = this.formApi.getFormData<CheckRideRequestEntity>();
    this.setupData();

    this.formApi.getFormDataChanges<CheckRideRequestEntity>().subscribe(checkride => {
      this.checkrideRequest = checkride;
      this.setupData();
    });

    this.formApi.getVariableContext<ExaminerBookingVariableContext>().subscribe(variables => {
      this.variableContext = variables;
    });
  }

  setupData() {
    this.hideDiscount = this.checkrideRequest.PilexosBookingCostPaymentPartyId != CheckRideRequestPaymentPartyAllItems.FlightSchool;
  }


  applyDiscountCode() {
    const bookingCost = this.formApi.getFormData<CheckRideRequestEntity>().PilexosBookingCost;

    this.variableContext = this.formApi.getVariableContextValue<ExaminerBookingVariableContext>();

    this.paymentRepositoryService.applyDiscountCode(this.paymentDiscountCode, bookingCost).subscribe(result => {
      this.paymentDiscountResult = result;

      if (result.IsValid) {
        const updateVariables: Partial<ExaminerBookingVariableContext> = {
          Discounted_Pilexos_Booking_Cost: result.FinalAmount,
          Discount_Code: this.paymentDiscountCode,
          HideCreditCard: result.FinalAmount === 0 ? true : false
        };

        this.formApi.patchVariableContext(updateVariables);

        this.variableContext = this.formApi.getVariableContextValue<ExaminerBookingVariableContext>();

        // const contextFG = this.formApi.formGroup.get(DwMdFormContextInfo.CONTEXT_FORM_GROUP) as FormGroup;

        // const variableContextFG = contextFG.controls[this.formApi.getFormConfig().variableContextDataKey] as FormGroup;

        // variableContextFG.patchValue(this.variableContext);

        return;
      }

      if (this.variableContext.Discounted_Pilexos_Booking_Cost != null || this.variableContext.Discount_Code) {
        const updateVariables: Partial<ExaminerBookingVariableContext> = {
          Discounted_Pilexos_Booking_Cost: null,
          Discount_Code: null,
          HideCreditCard: false
        };

        this.formApi.patchVariableContext(updateVariables);

        this.variableContext = this.formApi.getVariableContextValue<ExaminerBookingVariableContext>();
      }
    });
  }

}
